import React, { useState } from "react";
import PropTypes from "prop-types";
import FormCard from "../../../../../../Lib/FormCard";
import FormSelect from "../../../../../../Lib/FormSelect";
import { validateFileUpload } from "../../../../../../Utils/validations";

const IdentityForm = ({ formData, onChange, errors, disabled, index = 0 }) => {
  const [fileError, setFileError] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [fileType, setFileType] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const error = validateFileUpload(file);
    setFileError(error || "");

    if (!error && file) {
      onChange("document", file);

      const fileURL = URL.createObjectURL(file);
      setFilePreview(fileURL);

      if (file.type.startsWith("image/")) {
        setFileType("image");
      } else if (file.type === "application/pdf") {
        setFileType("pdf");
      } else {
        setFileType("unsupported");
      }
    } else {
      setFilePreview(null);
      setFileType("");
    }
  };

  return (
    <FormCard
      title={index > 0 ? `Identity Details ${index}` : "Identity Details"}
    >
      <div className="col-md-6">
        <FormSelect
          label="Identity Type"
          icon="bi bi-images"
          name="identityType"
          value={formData.identityType}
          onChange={handleInputChange}
          options={[
            { value: "aadhar", label: "Aadhaar" },
            { value: "driving_license", label: "Driving License" },
            { value: "passport", label: "Passport" },
          ]}
          // required
          disabled={disabled}
          error={errors.identityType}
        />
      </div>

      <div className="col-md-12">
        <label className="form-label text-muted">Identity Upload</label>
        <input
          type="file"
          className="form-control"
          accept="image/*,application/pdf"
          onChange={handleFileChange}
          disabled={disabled}
        />
        {fileError && <div className="text-danger">{fileError}</div>}

        {(filePreview || formData.frontend_url) && (
          <div className="mt-3">
            {fileType === "image" ||
            (!fileType &&
              /\.(jpe?g|png|gif|bmp|webp)$/i.test(formData.frontend_url)) ? (
              <img
                src={filePreview || formData.frontend_url}
                alt="Preview"
                className="img-fluid rounded border"
                width="500"
                height="500"
              />
            ) : fileType === "pdf" ||
              (!fileType && /\.pdf$/i.test(formData.frontend_url)) ? (
              <embed
                src={filePreview || formData.frontend_url}
                type="application/pdf"
                width="100%"
                height="400px"
              />
            ) : (
              <img
                src={filePreview || formData.frontend_url}
                alt="Fallback Preview"
                className="img-fluid rounded border"
                width="500"
                height="500"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.replaceWith(
                    Object.assign(document.createElement("p"), {
                      className: "text-danger",
                      textContent: "Unsupported or broken preview.",
                    })
                  );
                }}
              />
            )}
          </div>
        )}
      </div>

      <div className="col-md-12">
        <div className="form-group">
          <label className="form-label text-muted">Comments</label>
          <textarea
            className={`form-control ${errors.comments ? "is-invalid" : ""}`}
            placeholder="Remarks"
            value={formData.comments}
            onChange={handleInputChange}
            name="comments"
            disabled={disabled}
          ></textarea>
          {errors.comments && (
            <div className="invalid-feedback">{errors.comments}</div>
          )}
        </div>
      </div>
    </FormCard>
  );
};

IdentityForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number,
};

export default IdentityForm;
